import { render, staticRenderFns } from "./monthSwitch.vue?vue&type=template&id=009c8cfb&scoped=true"
import script from "./monthSwitch.vue?vue&type=script&lang=js"
export * from "./monthSwitch.vue?vue&type=script&lang=js"
import style0 from "./monthSwitch.vue?vue&type=style&index=0&id=009c8cfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009c8cfb",
  null
  
)

export default component.exports